import type { CryptoAsset } from "~/types/assets.types";

export const calculateCryptoTotalPurchase = (userProduct: CryptoAsset) => {
  const coins = userProduct?.cryptoData || [];

  return coins.map((coin) => {
    const purchasePrice = coin?.purchasePrice || 0;
    const amount = coin?.amount || 0;
    const purchaseFee = coin?.purchaseFee || 0;

    return purchasePrice * amount + purchasePrice * amount * purchaseFee / 100;
  });
};
